import { LocationData } from '../interfaces/generalInterface';
import { FleetPaymentMode } from './enums';

export const DEFAULT_LOCATION_FLEET_SETTINGS = {
  enableFleetDiscount: false,
  fleetDiscount: '',
  fleetPaymentMode: null as number | null,
};

export const getDisabledFleetSettings = () => ({ ...DEFAULT_LOCATION_FLEET_SETTINGS });

export const isEnabledFlag = (value: unknown): boolean =>
  value === true || value === 1 || value === '1' || value === 'true';

export const sanitizeDiscountPercentInput = (value: string): string | null => {
  if (value === '') {
    return '';
  }
  if (!/^\d{0,3}(\.\d{0,2})?$/.test(value)) {
    return null;
  }
  if (Number(value) > 100) {
    return null;
  }
  return value;
};

export const isValidFleetDiscountPercent = (value?: string | null): boolean => {
  if (value === undefined || value === null || String(value).trim() === '') {
    return false;
  }
  if (!/^\d+(\.\d{1,2})?$/.test(String(value).trim())) {
    return false;
  }
  const amount = Number(value);
  return Number.isFinite(amount) && amount >= 0 && amount <= 100;
};

const toDiscountString = (value: unknown): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  return String(value);
};

const toDiscountNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
};

export const parseFleetPaymentMode = (value: unknown): number | null => {
  if (value === FleetPaymentMode.CreditCard || value === '1' || value === 1) {
    return FleetPaymentMode.CreditCard;
  }
  if (value === FleetPaymentMode.ByCheck || value === '2' || value === 2) {
    return FleetPaymentMode.ByCheck;
  }
  const normalized = String(value ?? '').trim().toLowerCase();
  if (normalized === 'credit card' || normalized === 'creditcard') {
    return FleetPaymentMode.CreditCard;
  }
  if (normalized === 'cheque' || normalized === 'by check' || normalized === 'check') {
    return FleetPaymentMode.ByCheck;
  }
  return null;
};

export const parseLocationFleetSettings = (data: any = {}) => {
  const enableFleetDiscount = isEnabledFlag(
    data?.HasFleetAccount ?? data?.hasFleetAccount ?? data?.enableFleetDiscount ?? data?.allowFleetDiscount ?? data?.fleetDiscountEnabled ?? data?.isFleetDiscount
  );

  return {
    enableFleetDiscount,
    fleetDiscount: enableFleetDiscount
      ? toDiscountString(data?.FleetDiscount ?? data?.fleetDiscount ?? data?.discount)
      : '',
    fleetPaymentMode: enableFleetDiscount
      ? parseFleetPaymentMode(
          data?.FleetPaymentMethod ?? data?.fleetPaymentMethod ?? data?.fleetPaymentMode ?? data?.modeOfPayment ?? data?.paymentMode
        )
      : null,
  };
};

export const getLocationFleetRequestFields = (data?: LocationData | null) => {
  const enabled = Boolean(data?.enableFleetDiscount);
  return {
    hasFleetAccount: enabled,
    fleetDiscount: enabled ? (toDiscountNumber(data?.fleetDiscount) ?? 0) : 0,
    fleetPaymentMethod: enabled ? (data?.fleetPaymentMode ?? 0) : 0,
  };
};
